"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.showdownConverter = void 0;
const showdown_1 = __importDefault(require("showdown"));
exports.showdownConverter = new showdown_1.default.Converter({
    tables: true,
    simpleLineBreaks: true,
    smoothLivePreview: true,
    openLinksInNewWindow: true,
    disableForced4SpacesIndentedSublists: true,
    ghCompatibleHeaderId: true,
    splitAdjacentBlockquotes: true,
    tasklists: true,
});
